import React, { InputHTMLAttributes } from "react";
import styled from "styled-components";
import { FontSize } from "@themes/Fonts";
import Styles from "@themes/Styles";
import { TextInputComponents } from "./TextInputComponents";

const TextInput = styled.input`
    font-size: ${FontSize.normal};
    font-family: inherit;
    color: ${(props) => props.theme.textColorPrimary};

    border: none;
    border-radius: ${Styles.borderRadiusSharp};
    width: 100%;
    background-color: ${(props) => props.theme.backgroundPrimary};

    &:focus,
    &:focus-visible {
        outline: none;
        font-size: ${FontSize.normal};
    }

    &:disabled {
        background-color: ${(props) => props.theme.backgroundSpecial};
    }
`;

interface LifeAtTextInputV2Props extends InputHTMLAttributes<HTMLInputElement> {
    readonly label?: string;
    readonly showBorder?: boolean;
    readonly errorMessage?: string;
    readonly className?: string;
}

export const LifeAtTextInputV2 = React.forwardRef(
    (props: LifeAtTextInputV2Props, ref: React.ForwardedRef<HTMLInputElement>) => {
        const { label, showBorder, errorMessage, className, ...rest } = { ...props };

        return (
            <TextInputComponents.TextAreaWrapper
                label={label}
                showBorder={showBorder}
                errorMessage={errorMessage}
                isDisabled={props.disabled}
                className={className}
            >
                <TextInput ref={ref} {...rest} />
            </TextInputComponents.TextAreaWrapper>
        );
    },
);
